export function toBase64Url(v: string): string {
	return v ? btoa(v).replaceAll('+', '-').replaceAll('/', '_') : '';
}

export function fromBase64Url(v: string): string {
	return v ? atob(v.replaceAll('-', '+').replaceAll('_', '/')) : v;
}
